<template>
    <div>
        <custom-tooltip border>
            <app-button icon @click="onClick">🛒</app-button>
            <template #tooltip>
                <div class="content-tooltip">
                    <span> Producto libre </span>
                </div>
            </template>
        </custom-tooltip>
        <app-dialog v-model="openModal" @close="closeModal">
            <template #header>
                <div class="mx-4 mt-2 flex">
                    <h3 class="text-lg">
                        Ingresa la información del producto libre
                    </h3>
                </div>
            </template>
            <div>
                <div
                    class="flex flex-col items-center justify-center max-w-md mx-auto w-full"
                >
                    <div class="w-full text-left mb-4">
                        <span class="break-words">
                            {{ introduction }}
                        </span>
                    </div>

                    <div class="w-full flex flex-col">
                        <custom-input
                            v-model="name"
                            class="w-full"
                            :label="labelConcept"
                            @focus="onFocusConcept"
                        />
                        <input-money-component
                            v-model="priceOffer"
                            class="w-full mt-6"
                            enabled
                            :label="labelValue"
                            icon="💲"
                            @focus="focus"
                        />
                        <custom-input
                            v-model="quantity"
                            class="w-full mt-6"
                            :label="labelQuantity"
                            type="number"
                            min="1"
                            @focus="focus"
                        />
                        <custom-input
                            v-model="size"
                            class="w-full mt-6"
                            :label="labelSize"
                            type="string"
                            min="1"
                            @focus="focus"
                        />
                    </div>

                    <div class="flex mb-4 mt-6">
                        <app-button
                            :disabled="isSubmitDisabled"
                            @click="pushAnonymousProduct"
                        >
                            Agregar producto libre ✔️
                        </app-button>
                    </div>
                </div>
            </div>
        </app-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import InputMoneyComponent from "@/components/utils/InputMoneyComponent.vue";

export default {
    name: "ProductAnonymousButton",
    components: {
        AppDialog,
        InputMoneyComponent,
        CustomInput
    },
    props: {
        introduction: {
            type: String,
            default:
                "Si el producto no está en el sistema, agrégalo como producto libre: escribe una descripción corta o el código de barras, y su precio.",
            required: false
        },
        labelQuantity: {
            type: String,
            default: "Cantidad *",
            required: false
        },
        labelValue: {
            type: String,
            default: "Precio *",
            required: false
        },
        labelSize: {
            type: String,
            default: "Tamaño",
            required: false
        },
        labelConcept: {
            type: String,
            default: "Concepto *",
            required: false
        },
        valueRequired: {
            type: Boolean,
            default: true,
            required: false
        }
    },
    emits: ["open", "close", "input"],
    data: () => ({
        openModal: false,
        priceOffer: 1000,
        quantity: 1,
        size: "",
        name: "No especifica nombre"
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        isSubmitDisabled() {
            return (
                (this.valueRequired && !this.priceOffer) ||
                !this.quantity ||
                !this.name
            );
        }
    },
    methods: {
        onClick() {
            this.$emit("open");
            this.openModal = true;
        },
        closeModal() {
            this.$emit("close");
        },
        pushAnonymousProduct() {
            this.$emit("input", {
                priceOffer: this.priceOffer || 0,
                quantity: this.quantity,
                size: this.size,
                product: {
                    name: this.name
                },
                appliedDiscountPerReference: 0
            });
            this.openModal = false;
            this.name = "No especifica nombre";
        },
        onFocusConcept() {
            if (this.name === "No especifica nombre") {
                this.name = "";
            }
            this.focus();
        },
        focus() {
            this.$emit("focus");
        }
    }
};
</script>
